import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { Observable, map, catchError, of } from 'rxjs';
import { Ticket } from '../data/ticket.model';
import { SOFTLINE_API_TICKET } from '../ticket.api';

@Injectable({ providedIn: 'root' })
export class TicketSearchService {
  readonly #dataAccess = inject(ApiDataAccess);

  search(id: string): Observable<Ticket[]> {
    return this.#dataAccess
      .get$<ResponseResult<Ticket>>({
        path: `${SOFTLINE_API_TICKET}/{{id}}`,
        pathParams: { id },
      })
      .pipe(
        map((o) => o.result),
        map((ticket) => (!!ticket ? [ticket] : [])),
        catchError(() => of([]))
      );
  }
}
